import io from 'socket.io-client'
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'

export default class {
    instance: this
    io: SocketIOClient.Socket
    constructor() {
        if (this.instance) {
            return this.instance
        }
        this.instance = this
        // const app = feathers()

        // console.log('connecting?')
        // this.io = io('localhost:3030')
        // this.io.on('connect', () => {
        //     this.io.emit(
        //         'create',
        //         'authentication',
        //         {
        //             strategy: 'jwt',
        //             accessToken: `eyJhbGciOiJIUzI1NiIsInR5cCI6ImFjY2VzcyJ9.eyJpc0Fub24iOnRydWUsInAiOmZhbHNlLCJnIjoiZiIsImlhdCI6MTU4NjUwNzE2MywiZXhwIjoxNTg2NTkzNTYzLCJhdWQiOiJodHRwczovL3lvdXJkb21haW4uY29tIiwiaXNzIjoiZmVhdGhlcnMiLCJzdWIiOiI1ZTkwMmQ5YTYzNzQwMDYwMzQ3NTIyZGYiLCJqdGkiOiIyZjVlOGE5Ny01M2UyLTQ3ZjgtOThlMS01ZGZjMTMxZDllYTYifQ.6L0AbR59785LbSksqHNCAuIphwSQV1WKUxsAL07TXGA`,
        //         },
        //         async (error: any, newAuthResult: any) => {
        //             console.log(newAuthResult)
        //             const a = await app.service('idea-cards').get('unrated');
        //             console.log(a);
        //             // this.io.emit('get', 'idea-cards', 'unrated', (error:any, message:any) => {
        //             //     console.log('Found message', message)
        //             // })
        //         }
        //     )
        // })
        // app.configure(socketio(this.io))
    }
}
